import { render, staticRenderFns } from "./PackageC.vue?vue&type=template&id=472cd9c0&"
import script from "./PackageC.vue?vue&type=script&lang=js&"
export * from "./PackageC.vue?vue&type=script&lang=js&"
import style0 from "./PackageC.vue?vue&type=style&index=0&id=472cd9c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports